import React, { Component } from "react";
import InteractiveMessage from "./interactiveChat";

const formatTime = (timeString) => {
    if (!timeString || typeof timeString !== "string") return "";
    const splitTimeString = timeString.split(":");
    if (splitTimeString.length < 2) return timeString;
    const hour24 = parseInt(splitTimeString[0], 10);
    const minute = splitTimeString[1];
    if (isNaN(hour24)) return timeString;
    const hour12 = hour24 % 12 || 12;
    const period = hour24 >= 12 ? "PM" : "AM";
    return `${hour12}:${minute} ${period}`;
};

const customMarkdown = (text) => {
    if (!text || typeof text !== "string") return "";
    if (/^[a-z0-9_]+(-[a-z0-9_]+)*$/.test(text.trim())) return text;
    let formatted = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
    formatted = formatted.replace(/_(.*?)_/g, "<em>$1</em>");
    formatted = formatted.replace(/\\n|\n/g, "<br/>");
    formatted = formatted.replace(/(https?:\/\/[^\s]+)/g, (url) =>
        `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`
    );
    return formatted;
};

const mediaImgStyle = {
    width: "100%", height: "250px", objectFit: "contain",
    borderRadius: 8, border: "1px solid var(--disabled-color)",
};

class Convo extends Component {
    constructor(props) {
        super(props);
        this.state = { isMobile: window.matchMedia("(max-width:600px)").matches };
    }

    componentDidMount() {
        this.mediaQuery = window.matchMedia("(max-width:600px)");
        this.handleMQ = (e) => this.setState({ isMobile: e.matches });
        this.mediaQuery.addEventListener("change", this.handleMQ);
    }

    componentWillUnmount() {
        if (this.mediaQuery) this.mediaQuery.removeEventListener("change", this.handleMQ);
    }

    getFileIcon(fileName) {
        if (!fileName) return <i className="fas fa-file" />;
        const ext = fileName.split(".").pop().toLowerCase();
        switch (ext) {
            case "pdf": return <i className="fas fa-file-pdf text-danger" />;
            case "xls":
            case "xlsx": return <i className="fas fa-th text-success" />;
            case "doc":
            case "docx": return <i className="fas fa-file-alt text-primary" />;
            default: return <i className="fas fa-file" />;
        }
    }

    downloadFile(url, name) {
        const a = document.createElement("a");
        a.href = url;
        a.download = name || "file";
        a.target = "_blank";
        a.click();
    }

    renderTextContent(content) {
        return (
            <div style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>
                <div dangerouslySetInnerHTML={{ __html: customMarkdown(content) }} />
            </div>
        );
    }

    render() {
        const { waMessageChats = [], status1, lastMsgRef, onReplyMessage } = this.props;
        const { isMobile } = this.state;

        return (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {status1 === "loading" ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        {waMessageChats?.length > 0 &&
                        Object.keys(waMessageChats[0]?.messages || {}).length > 0 ? (
                            <>
                                {waMessageChats.map((convo) =>
                                    Object.entries(convo.messages).map(([date, msgs], dateIndex) => (
                                        <React.Fragment key={date}>
                                            <div className="text-center my-1">
                                                <span style={{
                                                    fontSize: 12, color: "var(--light-bg)",
                                                    backgroundColor: "var(--btn-12)",
                                                    padding: "2px 10px", borderRadius: 8,
                                                }}>
                                                    {date}
                                                </span>
                                            </div>

                                            {[...msgs]
                                                .sort((a, b) => {
                                                    if (a.time !== b.time) return a.time.localeCompare(b.time);
                                                    return (a.id || 0) - (b.id || 0);
                                                })
                                                .map((msg, idx) => {
                                                    const repliedMsg = msg.reply_id
                                                        ? msgs.find((m) => m.id === msg.reply_id)
                                                        : null;

                                                    const isLastMsg =
                                                        dateIndex === Object.entries(convo.messages).length - 1 &&
                                                        idx === msgs.length - 1;

                                                    const isMedia = ["image", "video", "interactive", "template"].includes(msg.media_type);

                                                    return (
                                                        <div
                                                            key={msg.id || idx}
                                                            ref={isLastMsg ? lastMsgRef : undefined}
                                                            className="reply-icon-parent"
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignSelf: msg.sender !== 1 ? "flex-end" : "flex-start",
                                                                maxWidth: isMedia ? "55%" : "65%",
                                                                wordBreak: "break-word",
                                                                overflowWrap: "break-word",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <div style={{
                                                                backgroundColor: msg.sender !== 1 ? "#DCF8C6" : "#FFF",
                                                                padding: "8px 12px",
                                                                borderRadius: 8,
                                                                boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                                                                position: "relative",
                                                            }}>
                                                                {msg?.user_name && (
                                                                    <div style={{ fontWeight: "bold", marginBottom: 4, color: "#555", fontSize: 13 }}>
                                                                        -&nbsp;{msg.user_name}
                                                                    </div>
                                                                )}

                                                                {repliedMsg && (
                                                                    <div style={{
                                                                        backgroundColor: "rgba(0,0,0,0.05)",
                                                                        borderLeft: "3px solid var(--primary)",
                                                                        padding: 8, marginBottom: 8, borderRadius: 4,
                                                                    }}>
                                                                        <small style={{ fontWeight: "bold", color: "#555" }}>
                                                                            {repliedMsg.sender === 1 ? "You" : repliedMsg.user_name || "Other"}
                                                                        </small>
                                                                        {repliedMsg.media_type === "text" && (
                                                                            <div style={{ fontSize: 13, color: "#666" }}>{repliedMsg.content}</div>
                                                                        )}
                                                                        {repliedMsg.media_type === "image" && (
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted mt-2">📷 Photo</small>
                                                                                <img src={repliedMsg.media_url} alt="Error" style={{ width: 50, height: 50 }} />
                                                                            </div>
                                                                        )}
                                                                        {repliedMsg.media_type === "video" && (
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted mt-2">🎥 Video</small>
                                                                                <video src={repliedMsg.media_url} controls style={{ width: 80, height: 50, objectFit: "contain", borderRadius: 8 }} />
                                                                            </div>
                                                                        )}
                                                                        {repliedMsg.media_type === "audio" && (
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted mt-2">🎤 Audio</small>
                                                                                <audio src={msg.media_url} controls style={{ width: 80, height: 50 }} />
                                                                            </div>
                                                                        )}
                                                                        {repliedMsg.media_type === "document" && (
                                                                            <small className="text-muted">📄 {repliedMsg.file_name || "Document"}</small>
                                                                        )}
                                                                        {repliedMsg.media_type === "location" && (
                                                                            <small className="text-muted">📍 Location</small>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                {msg.media_type === "text" && this.renderTextContent(msg.content)}

                                                                {msg.media_type === "image" && (
                                                                    <>
                                                                        <img src={msg.media_url} alt="media" style={mediaImgStyle} />
                                                                        {msg.content && this.renderTextContent(msg.content)}
                                                                    </>
                                                                )}

                                                                {msg.media_type === "video" && (
                                                                    <>
                                                                        <video src={msg.media_url} controls style={{ width: "100%", height: 300, objectFit: "contain", borderRadius: 8 }} />
                                                                        {msg.content && this.renderTextContent(msg.content)}
                                                                    </>
                                                                )}

                                                                {msg.media_type === "audio" && (
                                                                    <>
                                                                        <audio src={msg.media_url} controls style={{ width: "100%", borderRadius: 8 }} />
                                                                        {msg.content && this.renderTextContent(msg.content)}
                                                                    </>
                                                                )}

                                                                {msg.media_type === "location" && (
                                                                    <a href={msg.content} target="_blank" rel="noopener noreferrer">
                                                                        <div style={{
                                                                            width: "100%", height: 200, backgroundColor: "#e8f5e9",
                                                                            display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8,
                                                                        }}>
                                                                            📍 View Location
                                                                        </div>
                                                                    </a>
                                                                )}

                                                                {msg.media_type === "document" && (
                                                                    <>
                                                                        <div style={{
                                                                            padding: 8, display: "flex", alignItems: "center", gap: 8,
                                                                            border: `1px solid ${msg.sender === 1 ? "#d4d2d2" : "var(--disabled-color)"}`,
                                                                        }}>
                                                                            {this.getFileIcon(msg.file_name)}
                                                                            <span
                                                                                style={{ cursor: "pointer", fontSize: 14 }}
                                                                                onClick={() => this.downloadFile(msg.media_url, msg.file_name)}
                                                                            >
                                                                                {msg?.file_name}
                                                                            </span>
                                                                        </div>
                                                                        {msg.content && this.renderTextContent(msg.content)}
                                                                    </>
                                                                )}

                                                                {msg?.media_type?.toLowerCase() === "template" && (
                                                                    <>
                                                                        {msg.template_content.map((item, idx) => (
                                                                            <div key={idx} style={{ marginBottom: 8 }}>
                                                                                {item.type?.toLowerCase() === "header" && item.format.toLowerCase() === "text" && (
                                                                                    <h6 style={{ fontWeight: "bold", color: "#000", whiteSpace: "pre-line" }}
                                                                                        dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}
                                                                                    />
                                                                                )}
                                                                                {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "image" && (
                                                                                    <img src={item.url} alt="Header" style={mediaImgStyle} />
                                                                                )}
                                                                                {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "video" && (
                                                                                    <video controls style={{ width: "100%", borderRadius: 8 }}>
                                                                                        <source src={item.url} type="video/mp4" />
                                                                                    </video>
                                                                                )}
                                                                                {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "document" && (
                                                                                    <div
                                                                                        onClick={() => this.downloadFile(item.url, "View Document")}
                                                                                        style={{
                                                                                            display: "flex", alignItems: "center", gap: 12,
                                                                                            padding: "12px 24px", borderRadius: 12,
                                                                                            border: "1px solid #d0d0d0", cursor: "pointer",
                                                                                            backgroundColor: "#f9f9f9",
                                                                                        }}
                                                                                    >
                                                                                        <span style={{ fontSize: 28 }}>{this.getFileIcon(msg.file_name)}</span>
                                                                                        <span style={{ fontWeight: 600, color: "#1976d2" }}>View Document</span>
                                                                                    </div>
                                                                                )}
                                                                                {item.type.toLowerCase() === "body" && (
                                                                                    <div style={{ color: "#000", whiteSpace: "pre-line", fontSize: 14 }}
                                                                                        dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}
                                                                                    />
                                                                                )}
                                                                                {item.type.toLowerCase() === "footer" && (
                                                                                    <small style={{ color: "#888" }}
                                                                                        dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}
                                                                                    />
                                                                                )}
                                                                                {item.type.toLowerCase() === "buttons" && (
                                                                                    <div className="row">
                                                                                        {item.buttons.map((button, btnIndex) => (
                                                                                            <div
                                                                                                key={btnIndex}
                                                                                                className={item.buttons.length > 3 ? "col-6 mb-1" : "col-12 mb-1"}
                                                                                            >
                                                                                                {button.type === "url" && (
                                                                                                    <a href={button.url} target="_blank" rel="noopener noreferrer"
                                                                                                        className="btn btn-outline-primary btn-sm w-100"
                                                                                                    >
                                                                                                        <i className="fas fa-external-link-alt mr-1" />{button.text}
                                                                                                    </a>
                                                                                                )}
                                                                                                {button.type === "PHONE_NUMBER" && (
                                                                                                    <a href={`tel:${button.phone_number}`}
                                                                                                        className="btn btn-outline-primary btn-sm w-100"
                                                                                                        style={{ fontSize: item.buttons.length > 3 ? 10 : undefined }}
                                                                                                    >
                                                                                                        <i className="fas fa-phone mr-1" />{button.text}
                                                                                                    </a>
                                                                                                )}
                                                                                                {button.type === "QUICK_REPLY" && (
                                                                                                    <button className="btn btn-primary btn-sm w-100">
                                                                                                        <i className="fas fa-comment mr-1" />{button.text}
                                                                                                    </button>
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                )}

                                                                {msg.media_type === "interactive" && (
                                                                    <InteractiveMessage msg={msg} />
                                                                )}

                                                                {/* Message tail */}
                                                                <div style={{
                                                                    width: 0, height: 0,
                                                                    borderTop: "8px solid transparent",
                                                                    borderBottom: "8px solid transparent",
                                                                    position: "absolute", bottom: 0,
                                                                    transform: "translateY(50%)",
                                                                    right: msg.sender === 1 ? "-8px" : "auto",
                                                                    left: msg.sender === 1 ? "auto" : "-8px",
                                                                }} />

                                                                {/* Time + status */}
                                                                <div style={{
                                                                    display: "flex", alignItems: "center",
                                                                    justifyContent: "flex-end", gap: 4,
                                                                    marginTop: 4, marginLeft: 24,
                                                                }}>
                                                                    <small className="text-muted">{formatTime(msg.time)}</small>

                                                                    {msg.sender !== 1 && (
                                                                        <>
                                                                            {msg.status === "failed" && (
                                                                                <i className="fas fa-times-circle" style={{ color: "red", marginLeft: 4, fontSize: 13 }} />
                                                                            )}
                                                                            {msg.status === "pending" && (
                                                                                <i className="far fa-clock" style={{ color: "gray", marginLeft: 4, fontSize: 13 }} />
                                                                            )}
                                                                            {msg.status === "sent" && (
                                                                                <i className="fas fa-check" style={{ color: "gray", marginLeft: 4, fontSize: 13 }} />
                                                                            )}
                                                                            {msg.status === "delivered" && (
                                                                                <i className="fas fa-check-double" style={{ color: "gray", marginLeft: 4, fontSize: 13 }} />
                                                                            )}
                                                                            {msg.status === "read" && (
                                                                                <i className="fas fa-check-double" style={{ color: "#34B7F1", marginLeft: 4, fontSize: 13 }} />
                                                                            )}
                                                                        </>
                                                                    )}

                                                                    {["image","video","document","audio","text","location"].includes(msg.media_type) && (
                                                                        <button
                                                                            className="btn btn-link btn-sm p-0 reply-icon"
                                                                            style={{ visibility: !isMobile ? "hidden" : "visible", color: "#666" }}
                                                                            onClick={() => onReplyMessage && onReplyMessage(msg)}
                                                                        >
                                                                            <i className="fas fa-reply" style={{ fontSize: 12 }} />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </React.Fragment>
                                    ))
                                )}
                            </>
                        ) : (
                            <p className="text-muted text-center mt-2">
                                <span style={{ color: "red" }}>**</span> Chat conversations not found <span style={{ color: "red" }}>**</span>
                            </p>
                        )}
                    </>
                )}
            </div>
        );
    }
}

export default Convo;
